import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { formatToRelativeTime, toCalendarTime, toTime } from '@/lib/time';
import type { DateInput } from '@/lib/time';

export type DateFormatType = 'relative' | 'calendar' | 'combined' | 'timeCombined';

export type DateFormatterProps = {
  date: DateInput;
  formatType?: DateFormatType;
  updateIntervalMs?: number;
};

function formatDate(date: DateInput, formatType: DateFormatType, locale: string): string {
  switch (formatType) {
    case 'relative':
      return formatToRelativeTime(date, locale);
    case 'calendar':
      return toCalendarTime(date, locale);
    case 'combined':
      return `${toCalendarTime(date, locale)}, ${formatToRelativeTime(date, locale)}`;
    case 'timeCombined':
      return `${toTime(date, locale)}, ${formatToRelativeTime(date, locale)}`;
  }
}

export function DateFormatter({ date, formatType = 'calendar', updateIntervalMs }: DateFormatterProps) {
  const { i18n } = useTranslation();
  const [, setTick] = useState(0);

  useEffect(() => {
    if (updateIntervalMs == null) {
      return;
    }

    const timer = window.setInterval(() => setTick((tick) => tick + 1), updateIntervalMs);
    return () => window.clearInterval(timer);
  }, [updateIntervalMs]);

  return <>{formatDate(date, formatType, i18n.language || 'en')}</>;
}
